import { Component, OnInit } from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
  selector: 'eci-proforma-invoice-form',
  templateUrl: './proforma-invoice-form.component.html',
  styleUrls: ['./proforma-invoice-form.component.scss']
})
export class ProformaInvoiceFormComponent extends InvoiceTemplateBase  implements OnInit {

  ngOnInit(): void {
      this.model = {
          ...this.template,
          ...this.invoice,
          customerCompany: {
              ...this.template.customerCompany,
              ...this.invoice.customerCompany
          }
      };
  }

}
